import en_US from './en_US.json';
import zh_TW from './zh_TW.json';
import zh_CN from './zh_CN.json';
import ar_SA from './ar_SA.json';
import bn_BD from './bn_BD.json';
import cs_CZ from './cs_CZ.json';
import da_DK from './da_DK.json';
import de_DE from './de_DE.json';
import el_GR from './el_GR.json';
import fa_IR from './fa_IR.json';
import fi_FI from './fi_FI.json';
import fr_FR from './fr_FR.json';
import he_IL from './he_IL.json';
import hi_IN from './hi_IN.json';
import hu_HU from './hu_HU.json';
import id_ID from './id_ID.json';
import it_IT from './it_IT.json';
import ja_JP from './ja_JP.json';
import ko_KR from './ko_KR.json';
import nl_NL from './nl_NL.json';
import no_NO from './no_NO.json';
import pl_PL from './pl_PL.json';
import pt_BR from './pt_BR.json';
import pt_PT from './pt_PT.json';
import ro_RO from './ro_RO.json';
import ru_RU from './ru_RU.json';
import sv_SE from './sv_SE.json';
import th_TH from './th_TH.json';
import tr_TR from './tr_TR.json';
import uk_UA from './uk_UA.json';
import ur_PK from './ur_PK.json';
import vi_VN from './vi_VN.json';

/** Locale codes map to existing translation files; for locales without independent translation, fallback to en */
const locales = {
  'en-US': en_US,
  'zh-CN': zh_CN,
  'zh-TW': zh_TW,
  'ar-SA': ar_SA,
  'bn-BD': bn_BD,
  'cs-CZ': cs_CZ,
  'da-DK': da_DK,
  'de-DE': de_DE,
  'el-GR': el_GR,
  'fa-IR': fa_IR,
  'fi-FI': fi_FI,
  'fr-FR': fr_FR,
  'he-IL': he_IL,
  'hi-IN': hi_IN,
  'hu-HU': hu_HU,
  'id-ID': id_ID,
  'it-IT': it_IT,
  'ja-JP': ja_JP,
  'ko-KR': ko_KR,
  'nl-NL': nl_NL,
  'no-NO': no_NO,
  'pl-PL': pl_PL,
  'pt-BR': pt_BR,
  'pt-PT': pt_PT,
  'ro-RO': ro_RO,
  'ru-RU': ru_RU,
  'sv-SE': sv_SE,
  'th-TH': th_TH,
  'tr-TR': tr_TR,
  'uk-UA': uk_UA,
  'ur-PK': ur_PK,
  'vi-VN': vi_VN,
};

export default locales;
